<template>
  <div>
    <vx-card v-if="showImportWidget">
      <div class="text-center pb-8">
        <h4 class="pb-2">You Are importing accounts with company registration number</h4>
        <p class="text-dark-grey">
          This will upload your account from the submitted document to the
          database.
        </p>
      </div>
      <div class="mb-8">
        <import-excel :onSuccess="loadDataInTable" :purpose="'enhanced_with_company_registration'"
          @created-csv-filename="getCsvFileName" />
      </div>
    </vx-card>
    <vx-card title="Now you need to match fields to import accounts." class="mt-5" v-if="showFieldComparision">
      <p>
        On the left are the fields from our database. On the right are the
        fields from the file you have uploaded. The matched fields will upload
        data to the specific field on the database.
      </p>

      <!-- <vs-progress  color="primary"></vs-progress>
      <p class="text-center mt-5">
        Please Wait Your Field Matching and Data is Being Processed
      </p> -->
      <div class="vx-row p-10">
        <div class="vx-col w-full md:w-1/3">
          <vs-list>
            <vs-list-header title="Database Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <v-select class="pb-10 pt-10" :options="list1" v-model="slot.dbfield" />
                </div>
                <div class="vx-col w-full md:w-1/5">
                  <vs-button color="primary" :key="index + 1" @click="deleteColumn(slot)" type="line" icon-pack="feather"
                    icon="icon-trash"></vs-button>
                </div>
              </div>
            </template>
            <p class="mb-3" style="color:red;" v-if="validation_message">
              {{ validation_message }}
            </p>
          </vs-list>
          <vs-button color="danger" icon-pack="feather" icon="icon-plus" @click="addAnother">Add another
            column</vs-button>
        </div>
        <div class="vx-col w-full md:w-1/3">
          <vs-list>
            <vs-list-header title="Uploaded Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in fieldgroups">
              <v-select :closeOnSelect="true" class="pb-10 pt-10" :options="list2" :key="index"
                v-model="slot.uploadfield" />
            </template>
          </vs-list>
        </div>
        <div class="vx-col w-full md:w-1/3">
          <h6>Note :</h6>
          <p class="text-dark-grey mt-2">
            1. Fields should not be empty.
          </p>
          <p class="text-dark-grey">
            2. Account required fields should be selected. <br>
          <p class="text-dark-grey ml-10">
            &#x2022; Company Name
          </p>
          <p class="text-dark-grey ml-10">
            &#x2022; Company Registration Number
          </p>
          <p class="text-dark-grey ml-10">
            &#x2022; Registered Office Country
          </p>
          <p class="text-dark-grey ml-10">
            &#x2022; Status
          </p>

          </p>
          <p class="text-dark-grey">
            3. If phone is selected, then its phone type and phone code should be selected.
          </p>
          <p class="text-dark-grey">
            4. If revenue is selected, then its currency code should be selected.
          </p>
          <p class="text-dark-grey">
            5. If switchboard is selected, then its switchboard phone code should be selected.
          </p>
          <p class="text-dark-grey">
            6. If site switchboard is selected, then its site switchboard phone code should be selected.
          </p>
          <div class="p-10">
            <vs-button @click="enhance()" color="primary" type="filled" style="float:right;">Proceed</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
  </div>
</template>

<script>
import defineAbilitiesFor from '@/config/abilities'
import ImportExcel from "@/components/excel/ImportExcel.vue";
import vSelect from "vue-select";
import axios from "@/axios.js";
import AccountAutocomplete from "@/components/autocomplete/AccountsAutocomplete.vue";
import moduleAccountsManagement from "@/store/accounts-management/moduleAccountsManagement.js";
export default {
  components: {
    ImportExcel,
    vSelect,
    AccountAutocomplete
  },
  data() {
    return {
      phoneTypes: [],
      selected_registered_office_country: null,
      correction_fields_array: [],
      vertical: null,
      selected_vertical: null,
      correction_fields: null,
      selected_registration_jurisdiction: null,
      currencyCodes: [],
      selected_sic_code: null,
      add_or_update_title: null,
      user_id: null,
      user_role: null,
      selected_head_office_country: null,
      abilities: null,
      field_array_columns: [],
      registered_office_address_1: null,
      registered_office_address_2: null,
      registered_office_address_3: null,
      registered_office_city: null,
      registered_office_county: null,
      registered_office_postcode: null,
      registered_office_country: null,
      head_office_address_1: null,
      head_office_address_2: null,
      head_office_address_3: null,
      head_office_city: null,
      head_office_county: null,
      head_office_postcode: null,
      company_category: null,
      sic_code: null,
      revenue: null,
      currency_code: null,
      registration_jurisdiction: null,
      no_of_employees: null,
      // sic_code_description: null,
      phone_type: null,
      phone_no: null,
      website: null,
      social_media: null,
      status: null,
      switchboard: null,
      company_name: null,
      selected_fields: null,
      registered_office_country_validation: null,
      EnhancedHeadOfficeAutocompleteComponentKey: 0,
      EnhancedRegOffAutocompleteComponentKey: 0,
      EnhancedSicCodeAutocompleteComponentKey: 0,
      EnhancedVerticalAutocompleteComponentKey: 0,
      EnhancedRegistrationJurisdictionAutocompleteComponentKey: 0,
      company_registration_number: null,
      country: null,
      isNewAccount: null,
      update_id: null,
      table: null,
      popupActive: false,
      uploadCompleted: false,
      notExisted: [],
      validation_message: "",
      fieldgroups: [
        {
          dbfield: "",
          count: 0,
          uploadfield: [],
          selection: true
        }
      ],
      allSelected: false,
      selected: [],
      count: 0,
      showFieldComparision: false,
      showImportWidget: true,
      tableData: [],
      header: [],
      sheetName: "",
      list2: [],
      uploaded_columns: [],
      accept_text: "Accept",
      acceptButtonColor: "primary",
      list1: [
        {
          id: 1,
          name: "company",
          value: "company",
          label: "Company",
          selection: true
        },
        {
          id: 2,
          name: "company_registration_number",
          value: "company_registration_number",
          label: "Company Registration Number",
          selection: true
        },
        {
          id: 3,
          name: "registered_office_country",
          value: "registered_office_country",
          selection: true,
          label: "Registered Office Country"
        },
        {
          id: 4,
          name: "status",
          value: "status",
          selection: true,
          label: "Status"
        },
        {
          id: 5,
          name: "head_office_country",
          value: "head_office_country",
          label: "Head Office Country",
          selection: true
        },
        {
          id: 6,
          name: "head_office_address_1",
          value: "head_office_address_1",
          selection: true,
          label: "Head Office Address 1"
        },
        {
          id: 7,
          name: "head_office_city",
          value: "head_office_city",
          selection: true,
          label: "Head Office City"
        },
       
        {
          id: 8,
          name: "switchboard",
          value: "switchboard",
          selection: true,
          label: "Switchboard"
        },
        {
          id: 9,
          name: "website",
          value: "website",
          selection: true,
          label: "Website"
        },
        {
          id: 10,
          name: "linkedin",
          value: "linkedin",
          selection: true,
          label: "Social Media"
        },
        {
          id: 11,
          name: "company_category",
          value: "company_category",
          selection: true,
          label: "Company Category"
        },

        {
          id: 12,
          name: "head_office_address_2",
          value: "head_office_address_2",
          selection: true,
          label: "Head Office Address 2"
        },
        {
          id: 13,
          name: "head_office_address_3",
          value: "head_office_address_3",
          selection: true,
          label: "Head Office Address 3"
        },
        {
          id: 14,
          name: "head_office_county",
          value: "head_office_county",
          selection: true,
          label: "Head Office County"
        },
        {
          id: 15,
          name: "head_office_postcode",
          value: "head_office_postcode",
          selection: true,
          label: "Head Office Postcode"
        },
        {
          id: 16,
          name: "registered_office_address_1",
          value: "registered_office_address_1",
          selection: true,
          label: "Registered Office Address 1"
        },
        {
          id: 17,
          name: "registered_office_address_2",
          value: "registered_office_address_2",
          selection: true,
          label: "Registered Office Address 2"
        },
        {
          id: 18,
          name: "registered_office_address_3",
          value: "registered_office_address_3",
          selection: true,
          label: "Registered Office Address 3"
        },
        {
          id: 19,
          name: "registered_office_city",
          value: "registered_office_city",
          selection: true,
          label: "Registered Office City"
        },
        {
          id: 20,
          name: "registered_office_county",
          value: "registered_office_county",
          selection: true,
          label: "Registered Office County"
        },
        {
          id: 21,
          name: "registered_office_postcode",
          value: "registered_office_postcode",
          selection: true,
          label: "Registered Office Postcode"
        },
        {
          id: 22,
          name: "phone",
          value: "phone",
          selection: true,
          label: "Phone No."
        },
        {
          id: 30,
          name: "phone_code",
          value: "phone_code",
          selection: true,
          label: "Phone Code"
        },
        {
          id: 23,
          name: "phone_type",
          value: "phone_type",
          selection: true,
          label: "Phone Type"
        },
        {
          id: 24,
          name: "sic_code",
          value: "sic_code",
          selection: true,
          label: "SIC Code"
        },
        {
          id: 25,
          name: "revenue",
          value: "revenue",
          selection: true,
          label: "Revenue"
        },
        {
          id: 26,
          name: "currency_code",
          value: "currency_code",
          selection: true,
          label: "Currency Code"
        },
        {
          id: 27,
          name: "no_of_employees",
          value: "no_of_employees",
          selection: true,
          label: "No of Employee"
        },
        {
          id: 28,
          name: "registration_jurisdiction",
          value: "registration_jurisdiction",
          selection: true,
          label: "Registration Jurisdiction"
        },
        {
          id: 29,
          name: "vertical",
          value: "vertical",
          selection: true,
          label: "Vertical"
        },
        {
          id: 31,
          name: "switchboard_phone_code",
          value: "switchboard_phone_code",
          selection: true,
          label: "Switchboard Phone Code"
        },
        {
          id: 32,
          name: "site_switchboard_phone_code",
          value: "site_switchboard_phone_code",
          selection: true,
          label: "Site Switchboard Phone Code"
        },
        {
          id: 33,
          name: "site_switchboard",
          value: "site_switchboard",
          selection: true,
          label: "Site Switchboard"
        },
      ]
    };
  },
  mounted() {
    // console.log(this.selected)
  },
  watch: {},
  methods: {
  
    enhance() {
      // let self = this
      // this.fieldgroups.map(function(ele){
      //   ele.user_id = self.user_id
      // })



      this.$vs.loading();
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/enhance",
          this.fieldgroups
        )
        .then(response => {
          if (response.data.status == "success") {
            if (response.data.data != 0) {
              this.validation_message = null;
              let data = {}
              data.table_name = response.data.data.table_name
              data.fields = response.data.data.fields

              // this.notExisted = response.data.data;
              // console.log("NOT EXISTS", this.notExisted)
              // this.showImportWidget = false;
              // this.showFieldComparision = false;
              // this.uploadCompleted = true;
              // this.field_array_columns = response.data.data[0].fields.split(",");
              // this.field_array_columns = this.field_array_columns.map(ele => ele.replace(/\s/g, ''))


              this.$router.push({ path: "/enhance_account_registration_number/update/" + btoa(JSON.stringify(data)) });




            } else {
              this.$router.go(0);
            }
          } else if (response.data.status == "not_empty") {
            this.validation_message = response.data.message;
            console.log(response.data.message);
          } else if (response.data.status == "reg_no_or_country") {
            this.validation_message = response.data.message;
          } else if (response.data.status == "phone_and_phone_type") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "switchboard_and_switchboard_phone_code") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "site_switchboard_and_site_switchboard_phone_code") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          } else if (response.data.status == "revenue_and_currency_code_key") {
            this.validation_message = response.data.message;
            console.log(this.validation_message);
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    getCsvFileName(value) {
      // alert(value)
    },
    capitalizeTheFirstLetterOfEachWord(words) {
      var separateWord = words.toLowerCase().split(' ');
      for (var i = 0; i < separateWord.length; i++) {
        separateWord[i] = separateWord[i].charAt(0).toUpperCase() +
          separateWord[i].substring(1);
      }
      return separateWord.join(' ');
    },
    updateRegOrCountry(data) {
      this.head_office_country = null
      this.company_name = null
      this.switchboard = null
      this.status = null
      this.social_media = null
      this.website = null
      this.phone_no = null
      this.phone_type = null
      this.phone_code = null
      this.sic_code = null
      this.registration_jurisdiction = null
      this.no_of_employees = null
      this.revenue = null
      this.currency_code = null
      this.company_category = null
      this.head_office_address_1 = null
      this.head_office_address_2 = null
      this.head_office_address_3 = null
      this.head_office_city = null
      this.head_office_county = null
      this.head_office_postcode = null
      this.registered_office_address_1 = null
      this.registered_office_address_2 = null
      this.registered_office_address_3 = null
      this.registered_office_city = null
      this.registered_office_county = null
      this.registered_office_postcode = null
      this.registered_office_country = null
      this.isNewAccount = "Y";
      this.add_or_update_title = "Please update the field and submit"
      this.selected_fields = data.fields;
      this.registered_office_country_validation = null;
      this.company_registration_number = data.enh_company_registration_number;
      this.company_name = data.enh_company;
      this.switchboard = data.enh_switchboard;
      this.status = data.enh_status;
      this.social_media = data.enh_linkedin;
      this.website = data.enh_web;
      this.phone_no = data.enh_phone;
      this.phone_code = data.enh_phone_code;
      this.phone_type = data.enh_phone_type;
      this.vertical = data.enh_vertical;
      this.sic_code = data.enh_sic_code;
      this.registration_jurisdiction = data.enh_registration_jurisdiction;
      this.head_office_country = data.enh_head_office_country;
      this.registered_office_country = data.enh_registered_office_country
      if (this.registered_office_country != null) {
        // this.head_office_country = this.capitalizeTheFirstLetterOfEachWord(this.head_office_country)
        this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = this.registered_office_country;
        this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value = this.registered_office_country;
      }
      if (moduleAccountsManagement.sic_codes_selected != undefined) {
        moduleAccountsManagement.sic_codes_selected = {}
      }
      if (this.$refs.EnhanchedSicCodeRef != undefined) {
        this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value = this.sic_code
        this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value = this.sic_code
      }

      if (moduleAccountsManagement.countries_selected != undefined) {
        moduleAccountsManagement.countries_selected = {}
      }
      if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {
        this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value = this.registration_jurisdiction
        this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value = this.registration_jurisdiction
      }

      if (moduleAccountsManagement.vertical_selected != undefined) {
        moduleAccountsManagement.vertical_selected = {}
      }
      if (this.$refs.EnhancedVerticalRef != undefined) {
        this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value = this.vertical
        this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value = this.vertical

      }
      if (moduleAccountsManagement.head_office_country_selected != undefined) {
        moduleAccountsManagement.head_office_country_selected = {}
      }
      if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {
        this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value = this.head_office_country
        this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value = this.head_office_country
      }
      this.no_of_employees = data.enh_no_of_employees;
      this.revenue = data.enh_revenue;
      this.currency_code = data.enh_currency_code
      this.company_category = data.enh_company_category;
      this.head_office_address_1 = data.enh_head_office_address_1;
      this.head_office_address_2 = data.enh_head_office_address_2;
      this.head_office_address_3 = data.enh_head_office_address_3;
      this.head_office_city = data.enh_head_office_city;
      this.head_office_county = data.enh_head_office_county;
      this.head_office_country = data.enh_head_office_country;
      this.head_office_postcode = data.enh_head_office_postcode;
      this.registered_office_address_1 = data.enh_registered_office_address_1;
      this.registered_office_address_2 = data.enh_registered_office_address_2;
      this.registered_office_address_3 = data.enh_registered_office_address_3;
      this.registered_office_city = data.enh_registered_office_city;
      this.registered_office_county = data.enh_registered_office_county;
      this.registered_office_postcode = data.enh_registered_office_postcode;

      if (data.correction_fields != null && data.correction_fields != '') {
this.correction_fields_array = JSON.parse(data.correction_fields)
}

    
      this.update_id = data.enh_id;
      this.table = data.table;
      this.popupActive = true;

    },
    getCountries(inputValue) {
      return this.$store
        .dispatch("accountsManagement/getCountries", inputValue)
        .then(response => {
          if (response) {
            let data = moduleAccountsManagement.state.countries;
            let mappedArray = [];
            for (const property in data) {
              mappedArray.push({
                id: data[property].id,
                name: data[property].name_1
              });
            }
            return mappedArray;
          }
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
          }
        })
    },
    submitUpdate() {


      this.$validator.validateAll().then(result => {
        if (result) {




          if (moduleAccountsManagement.registered_office_country_selected != undefined) {
            this.registered_office_country = moduleAccountsManagement.registered_office_country_selected.name;
            if (this.registered_office_country == undefined) {
              this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value
              this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value
            }
          } else {
            this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value
            this.registered_office_country = this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value
          }

          if (moduleAccountsManagement.head_office_country_selected != undefined) {
            this.head_office_country = moduleAccountsManagement.head_office_country_selected.name;
            if (this.head_office_country == undefined) {
              if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {

                this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value
                this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value
              }
            }
          } else {
            if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {

              this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value
              this.head_office_country = this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value
            }
          }


          if (moduleAccountsManagement.sic_codes_selected != undefined) {
            this.sic_code = moduleAccountsManagement.sic_codes_selected.name;
            if (this.sic_code == undefined) {
              if (this.$refs.EnhanchedSicCodeRef != undefined) {
                this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value
                this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value
              }
            }
          }
          else {
            if (this.$refs.EnhanchedSicCodeRef != undefined) {
              this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value
              this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value
            }
          }
          if (moduleAccountsManagement.countries_selected != undefined) {
            this.registration_jurisdiction = moduleAccountsManagement.countries_selected.name;
            if (this.registration_jurisdiction == undefined) {
              if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {

                this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value
                this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value
              }
            }
          }

          else {
            if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {

              this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value
              this.registration_jurisdiction = this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value
            }
          }
          if (moduleAccountsManagement.vertical_selected != undefined) {
            this.vertical = moduleAccountsManagement.vertical_selected.vertical;
            if (this.vertical == undefined) {
              if (this.$refs.EnhancedVerticalRef != undefined) {

                this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value
                this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value
              }
            }
          }

          else {
            if (this.$refs.EnhancedVerticalRef != undefined) {

              this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value
              this.vertical = this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value

            }

          }


          if (this.registered_office_country == '') {
            this.registered_office_country = null
          }

          if (this.registered_office_country == null) {
            this.registered_office_country_validation =
              "Registered Office Country is required.";
            return false;
          } else {
            this.registered_office_country_validation = null

          }






          let updateData = { fieldValues: {} };
          updateData.id = this.update_id;
          updateData.company_registration_number = this.company_registration_number;
          updateData.registered_office_country = this.registered_office_country;
          updateData.isNewAccount = this.isNewAccount;
          updateData.fields = this.selected_fields;
          updateData.fieldValues.enh_company = this.company_name;
          updateData.fieldValues.enh_switchboard = this.switchboard;
          updateData.fieldValues.enh_status = this.status;
          updateData.fieldValues.enh_social_media = this.social_media;
          updateData.fieldValues.enh_website = this.website;
          updateData.fieldValues.enh_phone_no = this.phone_no;
          updateData.fieldValues.enh_phone_code = this.phone_code;
          updateData.fieldValues.enh_phone_type = this.phone_type;
          updateData.fieldValues.enh_company_category = this.company_category;
          updateData.fieldValues.enh_head_office_address_1 = this.head_office_address_1;
          updateData.fieldValues.enh_head_office_address_2 = this.head_office_address_2;
          updateData.fieldValues.enh_head_office_address_3 = this.head_office_address_3;
          updateData.fieldValues.enh_head_office_city = this.head_office_city;
          updateData.fieldValues.enh_head_office_county = this.head_office_county;
          updateData.fieldValues.enh_head_office_country = this.head_office_country;
          updateData.fieldValues.enh_head_office_postcode = this.head_office_postcode;
          updateData.fieldValues.enh_registered_office_address_1 = this.registered_office_address_1;
          updateData.fieldValues.enh_registered_office_address_2 = this.registered_office_address_2;
          updateData.fieldValues.enh_registered_office_address_3 = this.registered_office_address_3;
          updateData.fieldValues.enh_registered_office_city = this.registered_office_city;
          updateData.fieldValues.enh_registered_office_county = this.registered_office_county;
          updateData.fieldValues.enh_registered_office_postcode = this.registered_office_postcode;
          updateData.fieldValues.enh_sic_code = this.sic_code;
          updateData.fieldValues.enh_vertical = this.vertical;
          updateData.fieldValues.enh_registration_jurisdiction = this.registration_jurisdiction;
          updateData.fieldValues.enh_revenue = this.revenue != null?this.revenue.replace(/,/g, ''):null
          updateData.fieldValues.enh_currency_code = this.currency_code;
          updateData.fieldValues.enh_no_of_employees = this.no_of_employees != null?this.no_of_employees.replace(/,/g, ''):null
          updateData.fieldValues.enh_sic_code = this.sic_code;
          updateData.fieldValues.enh_vertical = this.vertical;
          updateData.fieldValues.enh_head_office_country = this.head_office_country;
          updateData.fieldValues.enh_registration_jurisdiction = this.registration_jurisdiction;
          updateData.fieldValues.enh_currency_code = this.currency_code;
          updateData.table = this.table;
          console.log(updateData)
          console.log("==================================")


          // this.$vs.loading();
          axios
            .post(
              this.$base_url + "/api/enhanced_accounts/update_reg_or_country",
              updateData
            )
            .then(response => {
              if (response.data.status == "success") {
                this.popupActive = false;
                if (moduleAccountsManagement.registered_office_country_selected != undefined) {
                  moduleAccountsManagement.registered_office_country_selected = {}
                } else {
                  this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.input.value = {}
                  this.$refs.enhanceRegisteredOfficeCountryRef.$refs.suggestComponent.value = {}
                }

                if (this.$refs.enhanceHeadOfficeCountryRef != undefined) {


                if (moduleAccountsManagement.head_office_country_selected != undefined) {
                  moduleAccountsManagement.head_office_country_selected = {}
                } else {
                  this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.input.value = null
                  this.$refs.enhanceHeadOfficeCountryRef.$refs.suggestComponent.value = null
                }
              }


                if (this.$refs.EnhanchedSicCodeRef != undefined) {

                  if (moduleAccountsManagement.sic_codes_selected != undefined) {
                    moduleAccountsManagement.sic_codes_selected = {}
                  } else {
                    this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.input.value
                    this.sic_code = this.$refs.EnhanchedSicCodeRef.$refs.suggestComponent.value
                  }

                }






                if (this.$refs.EnhancedRegistrationJurisdictionRef != undefined) {

                  if (moduleAccountsManagement.countries_selected != undefined) {
                    moduleAccountsManagement.countries_selected = {}
                  } else {
                    this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.input.value = null
                    this.$refs.EnhancedRegistrationJurisdictionRef.$refs.suggestComponent.value = null
                  }


                }


                if (this.$refs.EnhancedVerticalRef != undefined) {

                  if (moduleAccountsManagement.vertical_selected != undefined) {
                    moduleAccountsManagement.vertical_selected.vertical = {}
                  } else {
                    this.$refs.EnhancedVerticalRef.$refs.suggestComponent.input.value = null
                    this.$refs.EnhancedVerticalRef.$refs.suggestComponent.value = {}
                  }


                }

             

                this.registered_office_country_validation = null
                this.$vs.loading.close();





                this.notExisted = response.data.data;
              }
              if (response.data.status == "completed") {
                this.popupActive = false;


                this.$vs.notify({
                  color: "success",
                  title: "Enhanced Account",
                  text: "The document has been enhanced to accounts"
                });
                this.fieldgroups = [
                  {
                    dbfield: "",
                    count: 0,
                    uploadfield: [],
                    selection: true
                  }
                ];
                this.uploadCompleted = false;
                this.showImportWidget = true;
              }
              if (response.data.status == "company_registration_number_exists") {
                this.popupActive = false;
                this.$vs.dialog({
                  color: "primary",
                  title: `Duplicate Company Registration Number`,
                  text:
                    "Company registration number already exists in the database.Please update it and submit again",
                  accept: this.acceptAlert
                });
              }








            })
            .catch(error => {
              console.log(error);
            });
        }

      })



    },
    acceptAlert() {
      this.popupActive = true;
    },
    finished() {
      let tableData = {};
      tableData.table_name = this.table;
      axios
        .post(
          this.$base_url + "/api/enhanced_accounts/finish_enhance",
          tableData
        )
        .then(response => {
          if (response.data.status == "success") {
            this.$vs.notify({
              color: "success",
              title: "Enhanced Account",
              text: "The document has been enhanced to accounts"
            });
            this.fieldgroups = [
              {
                dbfield: "",
                count: 0,
                uploadfield: [],
                selection: true
              }
            ];
            this.uploadCompleted = false;
            this.showImportWidget = true;
          }
          this.$vs.loading.close();
        })
        .catch(error => {
          console.log(error);
        });
    },
    addAnother: function () {
      this.fieldgroups.push({
        dbfield: "",
        uploadfield: [],
        count: ++this.count
      });
    },
    deleteColumn(slot) {
      console.log(this.fieldgroups);
      this.fieldgroups = this.fieldgroups.filter(function (ele) {
        return ele != slot;
      });
      console.log(slot);
      // this.fieldgroups.pop(slot);
    },
    loadDataInTable({ header }) {
      // console.log(header);
      header.map(function (el) {
        var o = Object.assign({}, el);
        o.name = el;
        return o;
      });
      this.list2 = header;
      console.log(this.list2)
      this.showImportWidget = false;
      this.showFieldComparision = true;
      this.$vs.loading.close();
    }
  },
  created() {
    var self = this
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    self.user_id = userInfo["uid"];
    self.user_role = userInfo["userRole"];
    defineAbilitiesFor().then(function (data) {
      self.abilities = data
    });
  }
};
</script>
<style scoped>
.correction_field_class {
  color: red;
}

.correction_field_input_class {
  border: 1px solid red;
}



.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}
</style>
